import React, { useState, useEffect } from "react";

import FormControl from "@material-ui/core/FormControl";
// import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import styles from "./styles.js";
import withStyles from "@material-ui/core/styles/withStyles";
import FormWarning from "./FormWarning"

const EasyCanadaRegionDropdown = props => {
  const [loading, setLoading] = useState(true);
  const [regionCodebook, setRegionCodebook] = useState([
    { v: 0, l: "Loading", s: "", c: 1 }
  ]);

  useEffect(() => {
    props.connectForm.setPropMounted(propName, true);
    return () => {
      props.connectForm.setPropMounted(propName, false);
    };
  }, []);

  if (loading) {
    props.connectForm
      .getCodebookDropdownOptions("guest.1/canadaregions")
      .then(r => {
        setRegionCodebook(r);
      });
    setLoading(false);
  }

  const { classes } = props;
  const propName = props.propName;

  return (
    <FormControl
      fullWidth
      className={classes.selectFormControl}
      error={props.connectForm.getState(propName) === "Error"}
    >
      {/* <InputLabel htmlFor={propName} className={classes.selectLabel}>
        Province
        {props.connectForm.isRequired(propName) ? (
          <span style={{ color: "red" }}>*</span>
        ) : (
          ""
        )}
      </InputLabel> */}
      <Select
        error={props.connectForm.getState(propName) === "Error"}
        MenuProps={{
          className: classes.selectMenu
        }}
        classes={{
          select: props.connectForm.getState(propName) === "Error" && props.connectForm.isRequired(propName)? 
          classes.newErrorClass : classes.select 
        }}
        value={props.connectForm.getValue(propName)}
        onChange={event =>
          props.connectForm.change(event.target.value, propName)
        }
        inputProps={{
          name: propName,
          id: propName
        }}
      >
        {regionCodebook.map((element, key) => {
          return (
            <MenuItem
              key={key}
              classes={{
                root: classes.selectMenuItem,
                selected: classes.selectMenuItemSelect
              }}
              value={element.v}
            >
              {`${element.l} (${element.s})`}
            </MenuItem>
          );
        })}
      </Select>
      <FormWarning
      isValid = { props.propName }
      isError = { props.connectForm.getState(propName) }
      errorMessage = { props.connectForm.getErrorMessage(propName) }
    />
    </FormControl>
  );
};

export default withStyles(styles)(EasyCanadaRegionDropdown);
